































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ChatMedia from './ChatMedia.vue';
import { ActionOptionEvent, ArticleExpandedEvent, BaseEvent, BaseMessage, BaseSystemMessage, NoneOfTheAboveEvent, RollbackEvent, SystemArticleMessage, SystemOption, SystemOptionEvent } from '@/common/bot/types';
import { ItemType, getInteractivePart } from '@/common/bot/lib';
import { MessageType, SystemEvent, MemberType } from '@/common/bot/enum';

@Component({
  components: {
    ChatMedia,
  },
})
export default class ChatMessageSwitch extends Vue {
  @Prop({ default: '' }) readonly addClass!: string;
  @Prop({ default: () => ({}) }) readonly message!: BaseMessage;

  readonly MessageType = MessageType;
  readonly MemberType = MemberType;

  get isInteractive () {
    return ItemType.isInteractiveMessage(this.message);
  }

  get interactivePart1 () {
    return getInteractivePart(this.message, 0);
  }

  get interactivePart2 () {
    return getInteractivePart(this.message, 1);
  }

  get isListMessage () {
    return ItemType.isListMessage(this.message);
  }

  get isTypingMessage () {
    return ItemType.isTypingMessage(this.message);
  }

  get showNoneOfTheAbove () {
    return ItemType.isListMessage(this.message) && this.message.config?.noneOfTheAbove?.show;
  }

  get isArticleMessage () {
    return ItemType.isArticleMessage(this.message);
  }

  get isChatMessage () {
    return ItemType.isChatMessage(this.message);
  }

  get isIssuesList () {
    return ItemType.isTransactionMessage(this.message);
  }

  get isSystemInteractionMessage () {
    return this.message.type === MessageType.RESOLUTION || this.isListMessage;
  }

  get isMediaMessage () {
    return ItemType.isMediaMessage(this.message);
  }

  sendEvent ($event: BaseEvent) {
    this.$emit('input', $event);
  }

  selectOption (message: BaseSystemMessage, selected: SystemOption) {
    const $event: SystemOptionEvent = {
      message,
      type: SystemEvent.LIST_OPTION_SELECTED,
      payload: { selected },
    };
    this.sendEvent($event);
  }

  selectNoneOfTheAbove (message: BaseSystemMessage) {
    const $event: NoneOfTheAboveEvent = {
      message,
      type: SystemEvent.NONE_OF_THE_ABOVE_SELECTED,
    };
    this.sendEvent($event);
  }

  rollback (message: BaseSystemMessage) {
    const $event: RollbackEvent = {
      message,
      type: SystemEvent.USER_ROLLBACK,
    };
    this.sendEvent($event);
  }

  openArticle (message: SystemArticleMessage) {
    const $event: ArticleExpandedEvent = {
      message,
      type: SystemEvent.ARTICLE_PREVIEW_EXPANDED,
    };
    this.sendEvent($event);
  }

  handleResolve (message: SystemArticleMessage, resolved: boolean) {
    const $event: ActionOptionEvent = {
      message,
      type: SystemEvent.USER_RESOLUTION_SELECTED,
      payload: { selected: resolved ? 'yes' : 'no' },
    };
    this.sendEvent($event);
  }
}
